export default "__VITE_ASSET__BkeMkJyE__"